import React, { Component } from "react";
import { useApiRequests } from "../../services/fetchApiServices/index";
import { CustomModal, NotificationPopup, LoadingSpinner } from "../../common";

export class FormAddUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newUserFullName: "",
      isModalOpen: false,
      isFormOpened: false,
      isLoading: this.props.isLoading,
    };
  }

  onNewUserFullNameChange = (event, value) => {
    this.setState({
      newUserFullName: event.target.value,
    });
  };

  handleModalToggle = () => {
    this.setState({ isModalOpen: !this.state.isModalOpen });
  };

  handleModalClose = () => {
    this.setState({ isModalOpen: false });
  };

  addNewUserButton = () => {
    this.setState({ isFormOpened: true });
  };

  handleNewUserButtonSubmit = () => {
    this.handleModalToggle();
  };

  handleResetForm = () => {
    this.setState({
      newUserFullName: ""
    });
  };

  handleCloseForm = () => {
    this.setState({
      isFormOpened: false,
    });
    this.handleResetForm();
  };

  handleAddNewUser = async () => {
    try {
      const apiRequests = useApiRequests();

      const response = await apiRequests.postAddNewUser(
        this.state.newUserFullName
      );

      if (response.status === 200) {
        this.props.fetchData();
      } else {
        // Handle error if needed
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  handleSubmitForm = () => {
    this.handleResetForm();
    this.setState({ isLoading: true, isModalOpen: false }, () => {
      setTimeout(() => {
        this.setState({
          newUserFullName: "",
          isLoading: false,
        });
      }, 700);
    });
    this.handleAddNewUser();
  };

  render() {
    return (
      <>
        {this.state.isFormOpened ? (
          <>
            <CustomModal
              handleModalClose={this.handleModalClose}
              handleSubmitForm={this.handleSubmitForm}
              isModalOpen={this.state.isModalOpen}
              message={`Do you want to add new employee: ${this.state.newUserFullName}?`}
            />
            <div className="form-horizontal col-xxl-6 col-xl-7 col-md-8 col-sm-8 col-xs-11">
              <div className="form-group">
                <label
                  htmlFor="name"
                  className="col-xl-4 col-sm-5 col-xs-5 control-label"
                >
                  New Employee's Full Name:
                </label>
                <div className="col-12">
                  <input
                    className="form-control"
                    name="name"
                    type="text"
                    id="name"
                    value={this.state.newUserFullName}
                    onChange={this.onNewUserFullNameChange}
                    placeholder="Person Full Name"
                  />
                </div>
              </div>

              <div className="form-group d-flex justify-content-between justify-content-sm-end align-items-xs-around">
                <button
                  type="button"
                  className="btn"
                  onClick={this.handleResetForm}
                >
                  Reset
                </button>
                <button
                  type="button"
                  className="btn"
                  onClick={this.handleCloseForm}
                >
                  Close
                </button>
                <button
                  type="button"
                  className={
                    this.state.newUserFullName.length
                      ? `btn btn-primary`
                      : `btn disabled`
                  }
                  onClick={this.handleModalToggle}
                >
                  Save
                </button>
              </div>
            </div>
            {this.state.isLoading && <LoadingSpinner />}
          </>
        ) : (
          <button
            type="button"
            className="btn btn-primary"
            onClick={this.addNewUserButton}
          >
            Add new employee
          </button>
        )}
      </>
    );
  }
}
